"use client";

const heroBannerId = "hero-banner";

export const getHeroBanner = () => {
  const banner = document.querySelector(`#${heroBannerId}`);
  return banner as HTMLVideoElement | null;
};

export const isHeroBanner = (videoElement: HTMLVideoElement | null) => {
  return videoElement?.id === heroBannerId;
};
